export default {
    back_login: 'Back to login page',
    retrieve_title: 'Retrieve password',
    retrieve_username: 'Email/Phone number',
    login_username: 'Please enter phone number/email',
    retrieve_submit: 'Retrieve now',
    login_account: 'Account format is incorrect!',
    reset_pwd: 'Reset password',
    account_have_registration: 'Please use this phone number to register a new account',
    go_register: 'Go to registration',
    reset_pwd_email_tip: 'Click "Send email", the verification email will be sent to the registered email {email}, please follow the email instructions for subsequent operations',
    password_reg: 'The password must be a combination of any two of lowercase letters, numbers, uppercase letters, and special characters, and must be at least 8 characters long!',
    send_email: 'Send email',
    send_repeat: 'Send again',
    check_email: 'Check email',
    send_email_success: 'Email sent successfully',
    get_code_text: 'Get verification code',
    s_reset_text: '{s}s to resend',
    reset_pwd_phone_tip: 'Click to get the verification code, the SMS will be sent to the registered phone {phone}',
    reset_pwd_reset_tip: 'It is recommended to use a combination of numbers, letters, and characters for the password to improve password security level',
    original_password: 'Original password',
    new_password: 'New password',
    confrim_password: 'Confirm password',
    common_reg: '{name} cannot be empty',
    security_verification: 'Security verification',
    required_null: 'Required field cannot be empty',
    security_tip: 'You can perform security verification through the following methods',
    security_type: 'Verification method',
    email: 'Email',
    phone: 'Phone number',
    select_pwd_type_title: 'Please select a password modification method',
    confirm_password_reg: 'The passwords you entered twice do not match!',
    online_pass_reset: 'Original password modification',
    online_pass_tip: ' Enter the "original password" to modify the password',
    online_pass_reset_email: 'Email modification',
    online_pass_reset_email_tip: 'Modify the password through logging in with "email"',
    online_pass_reset_phone: 'Phone number modification',
    online_pass_reset_phone_tip: 'Enter the "SMS verification code" to modify the password',
    captcha: 'Captcha',
    code_tips: 'Please enter the mobile verification code',
    please_enter: 'Please enter',
    login_mobile: 'Please enter phone number',
    next: 'Next step',
    save: 'Save',
    prompt: 'Prompt',
    determine: 'Determine',
    send_sms_success: 'SMS verification code sent successfully',
    change_success: 'Modified successfully',
    sms_reg: 'SMS verification',
    password: 'Set password',
    re_password: 'Confirm password',
    code_required: 'Please enter the verification code',
    old_password: 'Please enter the original password',
    password_required: 'Password cannot be empty',
    email_reg: 'Email format is incorrect',
    upload_file_reg: 'Please upload a file in the {format} format',
    select_num_reg: 'The number of selections cannot exceed {num}',
    account_have_reg: 'The current input phone number or email already exists, please use this account to log in directly or retrieve the password!',
    account_have_Perfect: 'This phone number already exists, do you want to bind it as a ticket holder for this user?',
    change_pwd_by_pwd: 'Original password method',
    change_pwd_by_phone: 'Phone number method',
    change_pwd_by_email: 'Through email method',
    auth_reg: 'Identity verification',
    change_pwd: 'Change password',
    account_have_email_reg: 'This email already exists, please use this email to log in directly or retrieve the password!',
    account_no_register: 'The account is not yet registered, please first register using this {value}!',

    compellation: 'Name',
    p_compellation: 'Please enter name',
    professional: 'Title',
    professional1: 'Full professor',
    professional2: 'Associate professor',
    professional3: 'Middle level',
    professional4: 'Primary level',
    professional5: 'Other',
    p_professional: 'Please select title',

    id_card: 'Your ID number',
    p_id_card: 'Please enter your ID number',
    bank_no: 'Your bank card number',
    p_bank_no: 'Please enter your bank card number',
    bank_branch_name: 'Bank branch name',
    p_bank_branch_name: 'Please enter the bank branch name',
    hand_sign: 'Handwritten signature',
    please_sign: 'Please sign',
    id_card_err: 'ID number format is incorrect',
    back_number: 'Bank card number',
    p_back_number: 'Please enter the bank card number',
    bank_name: 'Bank name',
    p_bank_name: 'Please select the bank name',
    back_user_name: 'Account holder name',
    p_back_user_name: 'Please enter the account holder name',
    back_user_phone: 'Account holder phone number',
    p_back_user_phone: 'Please enter the account holder phone number',
    back_user_company: 'Account holder company name',
    p_back_user_company: 'Please enter the account holder company name',

    city: 'City',
    p_city: 'Please select city',
    province: 'Province',
    p_province: 'Please select province',
    country: 'Country',
    p_country: 'Please select country',
    perfect_info: 'Please complete information',
    job: 'On-site job position',
    p_job: 'Please select on-site job position',
    identity: 'Staff identity',
    p_identity: 'Please select staff identity',
    old_pwd: 'Old password'
};